module.exports = __webpack_public_path__ + "img/lunbo3@2x.fe8fd675.png";